(function () {
  const CATALOG_HANDLES = new Set(['all', 'produits', 'tous-les-produits', 'products']);

  const TAG_TO_VARIANT = {
    Loose: 'loose',
    'Gradé': 'grade',
    Display: 'frontpage',
    'Lots de cartes': 'lots-de-carte',
    'Lots de carte': 'lots-de-carte',
    'Lot de cartes': 'lots-de-carte',
  };

  const ACTIVE_LINK_BY_VARIANT = {
    frontpage: 'displays',
    'lots-de-carte': 'lots',
    loose: 'loose',
    grade: 'grade',
  };

  /** @param {URLSearchParams} params */
  function variantKeyFromParams(params) {
    const tag = params.get('filter.p.tag') || '';
    return TAG_TO_VARIANT[tag] || 'catalog-hub';
  }

  function parseConfig() {
    const el = document.getElementById('pokespott-hero-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  }

  /** @param {string[][]} highlights */
  function renderHighlights(highlights) {
    return highlights
      .map(
        ([label, note]) => `
      <li class="pokespott-collection-hero__stat">
        <span class="pokespott-collection-hero__stat-label">${label}</span>
        ${note ? `<span class="pokespott-collection-hero__stat-note">${note}</span>` : ''}
      </li>`
      )
      .join('');
  }

  /** @param {{ displays: string, lots: string, loose: string, grade: string }} links @param {string} activeKey */
  function renderLinks(links, activeKey) {
    const items = [
      { key: 'displays', label: 'Displays', note: 'booster box JP', href: links.displays },
      { key: 'lots', label: 'Lots', note: 'tri par rareté', href: links.lots },
      { key: 'loose', label: 'Loose', note: "cartes à l'unité", href: links.loose },
      { key: 'grade', label: 'Gradé', note: 'cartes certifiées', href: links.grade },
    ];

    return items
      .map(
        (item) => `
      <li class="pokespott-collection-hero__stat">
        <a class="pokespott-collection-hero__stat-link${activeKey === item.key ? ' is-active' : ''}" href="${item.href}">
          <span class="pokespott-collection-hero__stat-label">${item.label}</span>
          <span class="pokespott-collection-hero__stat-note">${item.note}</span>
        </a>
      </li>`
      )
      .join('');
  }

  /**
   * @param {HTMLElement} panel
   * @param {object} config
   * @param {string} variantKey
   */
  function applyVariant(panel, config, variantKey) {
    const variant = config.variants[variantKey];
    if (!variant) return;

    const eyebrow = panel.querySelector('.pokespott-collection-hero__eyebrow');
    const title = panel.querySelector('.pokespott-collection-hero__title');
    const lead = panel.querySelector('.pokespott-collection-hero__lead');
    const strip = panel.querySelector('[data-pokespott-hero-strip]');

    if (eyebrow) {
      eyebrow.textContent = variant.eyebrow;
      eyebrow.hidden = !variant.eyebrow;
    }
    if (title) title.textContent = variant.title;
    if (lead) {
      lead.textContent = variant.lead;
      lead.hidden = !variant.lead;
    }

    if (!strip) return;

    if (variant.mode === 'links') {
      strip.className = 'pokespott-collection-hero__strip pokespott-collection-hero__strip--links';
      strip.innerHTML = renderLinks(config.links, ACTIVE_LINK_BY_VARIANT[variantKey] || '');
      strip.hidden = false;
      return;
    }

    if (variant.mode === 'none') {
      strip.className = 'pokespott-collection-hero__strip';
      strip.innerHTML = '';
      strip.hidden = true;
      return;
    }

    strip.className = 'pokespott-collection-hero__strip';
    strip.innerHTML = renderHighlights(variant.highlights);
    strip.hidden = false;
  }

  /** @param {URLSearchParams} params */
  function updateTypeFilterPills(params) {
    const tag = params.get('filter.p.tag');
    const pills = document.querySelectorAll('.pokespott-type-filters__pill');
    if (!pills.length) return;

    pills.forEach((pill) => {
      pill.classList.remove('is-active');
      if (!tag) return;
      const href = pill.getAttribute('href') || '';
      if (href.includes(`filter.p.tag=${encodeURIComponent(tag)}`) || href.includes(`filter.p.tag=${tag}`)) {
        pill.classList.add('is-active');
      }
    });
  }

  /** @param {URLSearchParams} params */
  function updateFromParams(params) {
    const section = document.querySelector('[data-pokespott-hero-adaptive]');
    if (!section) return;

    const handle = section.getAttribute('data-collection-handle') || '';
    if (!CATALOG_HANDLES.has(handle)) return;

    const config = parseConfig();
    const panel = section.querySelector('.pokespott-collection-hero__panel');
    if (!config || !panel) return;

    applyVariant(panel, config, variantKeyFromParams(params));
    updateTypeFilterPills(params);
  }

  function init() {
    updateFromParams(new URLSearchParams(window.location.search));
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('filter:update', (event) => {
    const params = event.detail?.queryParams;
    if (params) updateFromParams(params);
  });
  window.addEventListener('popstate', init);

  init();
})();
